import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { PermissionDirective, PermissionService } from '@abp/ng.core';
import { PermissionConstants } from 'src/core/constants/permission.constant';
import { LocalizationPipe } from '@abp/ng.core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { CrmSegmentDefinitionsMainComponent } from '../crm-segment-definitions/components/crm-segment-definitions-main/crm-segment-definitions-main.component';
import { StateDefinitionMainComponent } from './components/state-definition-main/state-definition-main.component';
import { SkillMainComponent } from './components/skill-main/skill-main.component';
import { WrapUpDefinitionMainComponent } from './components/wrap-up-definition-main/wrap-up-definition-main.component';
import { DeclineReasonMainComponent } from './components/decline-reason-main/decline-reason-main.component';

const WorkEnvironmentTab = {
  States: 1,
  Status: 2,
  Skills: 3,
  WrapUpCodes: 4,
  DeclineReasons: 5,
} as const;

@Component({
  selector: 'app-work-environment-settings',
  standalone: true,
  imports: [
    CommonModule,
    LocalizationPipe,
    PermissionDirective,
    NgbNavModule,
    StateDefinitionMainComponent,
    SkillMainComponent,
    WrapUpDefinitionMainComponent,
    DeclineReasonMainComponent,
  ],
  templateUrl: './work-environment-settings.component.html',
  styleUrl: './work-environment-settings.component.scss',
})
export class WorkEnvironmentSettingsComponent implements OnInit {
  protected readonly PermissionConstants = PermissionConstants;
  readonly WorkEnvironmentTab = WorkEnvironmentTab;
  activeTab: number = WorkEnvironmentTab.Status;
  protected readonly crmSegmentDefinitionsMainComponent = CrmSegmentDefinitionsMainComponent;
  private readonly permissionService = inject(PermissionService);

  ngOnInit(): void {
    this.applyInitialTabFromQuery();
  }

  get canManageAgentSkills(): boolean {
    return this.permissionService.getGrantedPolicy(PermissionConstants.agentManagement);
  }

  get canManageCrmSettings(): boolean {
    return this.permissionService.getGrantedPolicy(PermissionConstants.canManageCrmSettings);
  }

  get canManageWrapUpCodes(): boolean {
    return this.permissionService.getGrantedPolicy(PermissionConstants.canManageWrapUpCodes);
  }

  get canManageDeclineReasons(): boolean {
    return this.permissionService.getGrantedPolicy(PermissionConstants.canManageDeclineReasons);
  }

  private applyInitialTabFromQuery(): void {
    const params = new URLSearchParams(window.location.search);
    const requestedTab = params.get('workEnvironmentTab')?.toLowerCase();

    if (requestedTab === 'states' && this.canManageCrmSettings) {
      this.activeTab = WorkEnvironmentTab.States;
      return;
    }

    if (requestedTab === 'skills' && this.canManageAgentSkills) {
      this.activeTab = WorkEnvironmentTab.Skills;
      return;
    }

    if (requestedTab === 'status') {
      this.activeTab = WorkEnvironmentTab.Status;
      return;
    }

    if (this.canManageCrmSettings) {
      this.activeTab = WorkEnvironmentTab.States;
    }
  }
}
